import { PARTICIPANT_TAG_SYSTEM } from '#src/codeSystems.ts'

export const DEMO_TAG = {
  system: PARTICIPANT_TAG_SYSTEM,
  code: 'DEMO',
  display: 'Demo',
} as const

export const LEAD_TAG = {
  system: PARTICIPANT_TAG_SYSTEM,
  code: 'LEAD',
  display: 'Lead',
} as const

export const ONSITE_TAG = {
  system: PARTICIPANT_TAG_SYSTEM,
  code: 'ONSITE',
  display: 'Onsite',
} as const

export const DELETED_TAG = {
  system: PARTICIPANT_TAG_SYSTEM,
  code: 'DELETED',
  display: 'Deleted',
} as const

export const DISENROLLMENT_SCHEDULED_TAG = {
  system: PARTICIPANT_TAG_SYSTEM,
  code: 'DISENROLLMENT_SCHEDULED',
  display: 'Disenrollment Scheduled',
} as const

export const DISENROLLED_TAG = {
  system: PARTICIPANT_TAG_SYSTEM,
  code: 'DISENROLLED',
  display: 'Disenrolled',
} as const

export const DISENROLLMENT_REASONS = [
  { value: 'relocation', label: 'Relocation' },
  { value: 'transition-of-care', label: 'Transition of Care' },
  { value: 'deceased', label: 'Deceased' },
  { value: 'dissatisfaction', label: 'Dissatisfaction' },
  { value: 'other', label: 'Other' },
] as const

export type DisenrollmentReason =
  (typeof DISENROLLMENT_REASONS)[number]['value']

// The closed set of participant tags an AI agent (Orbit AI `proposeTagEdit`)
// may add or remove. Deliberately excludes lifecycle tags an agent must not
// flip conversationally — DELETED (soft-delete), DISENROLLED /
// DISENROLLMENT_SCHEDULED (own enrollment workflows + cleanup subscription). A
// closed taxonomy is the safety boundary: the tool's input enum is derived from
// these codes, so the model can neither name a tag outside the set nor target a
// resource other than the participant. Widening the agent's reach means adding
// here intentionally, never opening the schema.
export const AI_EDITABLE_PARTICIPANT_TAGS = [
  DEMO_TAG,
  LEAD_TAG,
  ONSITE_TAG,
] as const

export type AiEditableParticipantTagCode =
  (typeof AI_EDITABLE_PARTICIPANT_TAGS)[number]['code']

// The Coding for an AI-editable participant tag code, or undefined when the
// code is outside the closed set. Callers building a mutation from validated
// tool input use this to map a code back to its full Coding (system + display).
export function aiEditableParticipantTag(
  code: string
): (typeof AI_EDITABLE_PARTICIPANT_TAGS)[number] | undefined {
  return AI_EDITABLE_PARTICIPANT_TAGS.find((tag) => tag.code === code)
}
